"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Button = require("../Button");
var _styles = require("./styles");
var _properties = require("../utils/properties");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class ConfirmationPopup extends _react.PureComponent {
  render() {
    const {
      cancelButtonLabel,
      onClose,
      isLoading,
      confirmButtonLabel,
      onConfirm,
      confirmButtonVariant,
      active,
      title,
      hasCloseBtn,
      message,
      className,
      visibleButtonsLimit,
      leftVisibleButtonsLimit,
      buttonsStrategy,
      image
    } = this.props;
    const actions = [_react.default.createElement(_Button.Button, {
      title: cancelButtonLabel,
      type: "button",
      onClick: onClose,
      disabled: isLoading,
      "data-test-role": "confirmation-modal-cancel-button"
    }), _react.default.createElement(_Button.Button, {
      title: confirmButtonLabel,
      type: "button",
      onClick: onConfirm,
      variant: confirmButtonVariant,
      disabled: isLoading,
      "data-test-role": "confirmation-modal-confirm-button"
    })];
    return _react.default.createElement("div", (0, _properties.getDataAttrsProps)(this.props), _react.default.createElement(_styles.ConfirmationModal, {
      active: active,
      onClose: onClose,
      title: title,
      actions: actions,
      isLoading: isLoading,
      hasCloseBtn: hasCloseBtn,
      visibleButtonsLimit: visibleButtonsLimit,
      leftVisibleButtonsLimit: leftVisibleButtonsLimit,
      buttonsStrategy: buttonsStrategy,
      className: className,
      image: image,
      icon: this.props.icon,
      testId: this.props.testId
    }, _react.default.createElement(_styles.ConfirmationMessage, null, message)));
  }
}
ConfirmationPopup.defaultProps = {
  active: false,
  confirmButtonVariant: 'primary',
  confirmButtonLabel: 'confirm',
  cancelButtonLabel: 'cancel',
  isLoading: false,
  hasCloseBtn: false,
  image: null
};
var _default = exports.default = ConfirmationPopup;